export default __webpack_public_path__ + "static/media/detail_main_img_1.510d923a.png";